const InputWrapper = ({ children }: { children: JSX.Element }) => <div className="mt-2 mb-2">{children}</div>;

export default InputWrapper;
